'use client';

import { useMemo } from 'react';
import { useSearchParams } from '@framework/next/navigation';
import { ABS_SECTOR_GROUPS, ALL_ABS_SECTOR_GROUP_KEYS } from '@/creditflowresearch/domain/Sector/constants';
import type { AbsSectorGroupKey } from '@/creditflowresearch/domain/Sector/AbsSectorGroup';
import {
  selectAbsSectorGroupKeysFromQuery,
} from '@/creditflowresearch/domain/Sector/selectors/selectAbsSectorGroupKeysFromQuery';
import type { IFilterSet } from '@/creditflowresearch/ui/common/hooks/filters/useFilterButtons';
import { transformToFilterSets } from './helpers/transformToFilterSets';

export const ABS_SECTORS_FILTER_KEY = 'sectors';

interface IUseAbsSectorFiltersResult {
  sectorFilterSet: IFilterSet,
  activeGroupKeys: AbsSectorGroupKey[],
}

export const useAbsSectorFilters = (): IUseAbsSectorFiltersResult => {
  const searchParams = useSearchParams();
  const sectorsQuery = searchParams.get(ABS_SECTORS_FILTER_KEY);

  const sectorFilterSet = useMemo(() => {
    const [filterSet] = transformToFilterSets([
      {
        key: ABS_SECTORS_FILTER_KEY,
        items: ABS_SECTOR_GROUPS.map(({ key, label }) => ({ id: key, abbreviation: label, queryName: key })),
        defaultActive: ALL_ABS_SECTOR_GROUP_KEYS,
      },
    ], Object.fromEntries(searchParams.entries()));

    return filterSet;
  }, [searchParams]);

  const activeGroupKeys = useMemo(
    () => selectAbsSectorGroupKeysFromQuery(sectorsQuery),
    [sectorsQuery],
  );

  return { sectorFilterSet, activeGroupKeys };
};
